import type { PostProcessPopupParams } from "ag-grid-enterprise";

/**
 * AG Grid remembers the last selected legacy column-menu tab for the whole
 * grid. Click the first tab (`filterMenuTab`, from global `menuTabs`) when the
 * header menu opens so it does not stay on `generalMenuTab`. Skip the click
 * when that tab is already selected — clicking the active tab closes the menu.
 */
export const alwaysOpenFirstColumnMenuTab = (
  params: PostProcessPopupParams
): void => {
  if (params.type !== "columnMenu") return;

  const firstTab = params.ePopup.querySelector<HTMLElement>(".ag-tab");
  if (firstTab && !firstTab.classList.contains("ag-tab-selected")) {
    firstTab.click();
  }
};
